/* eslint-disable react/display-name */
import classNames from 'classnames';
import styles from './WidgetContainer.module.scss';

const WidgetContainer = ({ children, isColumn, minSize, className, borderless, style }) => (
  <div
    className={classNames(styles['widget-container'], className, {
      [styles['widget-container--columns']]: isColumn,
      [styles['widget-container--min-size']]: minSize,
      [styles['borderless']]: borderless,
    })}
    style={style}
  >
    {children}
  </div>
);

export { WidgetContainer as default, WidgetContainer };
